<div class="content-wrapper animated fadeIn">

  <section class="content-header home-header">
    <div class="home-header-inner">
      <div>
        <h1 class="home-title">Home <span class="home-subtitle">Informações do sistema</span></h1>
        <ol class="breadcrumb home-breadcrumb">
          <li><a routerLink="/home"><i class="fa fa-home"></i> Home</a></li>
          <li class="active">Here</li>
        </ol>
      </div>
    </div>
  </section>

  <section class="content home-content">

    <!-- LOADING STATE -->
    <ng-container *ngIf="exibirCarregamentoHome">
      <div class="home-loading">
        <div class="home-loading-spinner">
          <i class="fa fa-circle-o-notch fa-spin"></i>
        </div>
        <p>Carregando informações, por favor aguarde...</p>
      </div>
    </ng-container>

    <!-- STAT CARDS -->
    <ng-container *ngIf="exibirConteudoHome">
      <div class="row stat-cards-row">

        <div class="col-sm-6 col-md-3">
          <div class="stat-card stat-card--red">
            <div class="stat-card__icon">
              <i class="fa fa-file"></i>
            </div>
            <div class="stat-card__body">
              <span class="stat-card__label">Projetos</span>
              <span class="stat-card__number">{{countProjetos}}</span>
              <span class="stat-card__desc">cadastrados</span>
            </div>
            <div class="stat-card__wave"></div>
          </div>
        </div>

        <div class="col-sm-6 col-md-3">
          <div class="stat-card stat-card--blue">
            <div class="stat-card__icon">
              <i class="fa fa-institution"></i>
            </div>
            <div class="stat-card__body">
              <span class="stat-card__label">Concedentes/U.A.</span>
              <span class="stat-card__number">{{countConcedentes}}</span>
              <span class="stat-card__desc">cadastrados</span>
            </div>
            <div class="stat-card__wave"></div>
          </div>
        </div>

        <div class="col-sm-6 col-md-3">
          <div class="stat-card stat-card--green">
            <div class="stat-card__icon">
              <i class="fa fa-building"></i>
            </div>
            <div class="stat-card__body">
              <span class="stat-card__label">Proponentes</span>
              <span class="stat-card__number">{{countProponentes}}</span>
              <span class="stat-card__desc">cadastradas</span>
            </div>
            <div class="stat-card__wave"></div>
          </div>
        </div>

        <div class="col-sm-6 col-md-3">
          <div class="stat-card stat-card--yellow">
            <div class="stat-card__icon">
              <i class="fa fa-users"></i>
            </div>
            <div class="stat-card__body">
              <span class="stat-card__label">Usuários</span>
              <span class="stat-card__number">{{countUsuarios}}</span>
              <span class="stat-card__desc">cadastrados</span>
            </div>
            <div class="stat-card__wave"></div>
          </div>
        </div>

      </div>
    </ng-container>

    <!-- MAIN CONTENT ROW -->
    <div class="row">

      <!-- NOTIFICAÇÕES -->
      <div class="col-sm-8">
        <div class="modern-card">
          <div class="modern-card__header">
            <div class="modern-card__title-group">
              <i class="fa fa-bell modern-card__title-icon"></i>
              <h3 class="modern-card__title">Últimas notificações</h3>
            </div>
            <div class="modern-card__actions">
              <div class="notif-filters">
                <a [routerLink]="['/notificacao/listar', 'informacoes']" class="notif-filter-link notif-filter-link--blue"
                  (mouseenter)="hoveredIcon = 'informacoes'" (mouseleave)="hoveredIcon = ''">
                  <i [ngClass]="hoveredIcon === 'informacoes' ? 'fas fa-circle' : 'far fa-circle'"></i>
                  Informações
                </a>
                <a [routerLink]="['/notificacao/listar', 'alerta']" class="notif-filter-link notif-filter-link--yellow"
                  (mouseenter)="hoveredIcon = 'alerta'" (mouseleave)="hoveredIcon = ''">
                  <i [ngClass]="hoveredIcon === 'alerta' ? 'fas fa-circle' : 'far fa-circle'"></i>
                  Alerta
                </a>
                <a [routerLink]="['/notificacao/listar', 'urgente']" class="notif-filter-link notif-filter-link--red"
                  (mouseenter)="hoveredIcon = 'urgente'" (mouseleave)="hoveredIcon = ''">
                  <i [ngClass]="hoveredIcon === 'urgente' ? 'fas fa-circle' : 'far fa-circle'"></i>
                  Urgente
                </a>
              </div>
              <div class="modern-card__btns">
                <button type="button" class="btn-modern btn-modern--outline" [routerLink]="['/notificacao/enviar']">
                  <i class="fa fa-send"></i> Enviar
                </button>
                <button type="button" class="btn-modern btn-modern--primary" [routerLink]="['/notificacao/listar', 'entrada']">
                  <i class="fa fa-bell"></i> Ver todas
                </button>
              </div>
            </div>
          </div>

          <div class="modern-card__body">
            <div class="notif-list">
              <div *ngIf="carregandoNotificacoes" class="notif-loading">
                <i class="fa fa-circle-o-notch fa-spin"></i>
                <span>Carregando notificações...</span>
              </div>
              <ng-container *ngIf="!carregandoNotificacoes">
              <div *ngFor="let item of listaNotificacao" class="notif-item"
                [class.notif-item--unread]="item.statusNotificacao !== 'Lida'"
                (click)="setaNotificacaoSessao(item)">
                <div class="notif-item__indicators">
                  <i class="notif-item__star"
                    [ngClass]="item.favorito ? 'fa fa-star text-yellow' : 'far fa-star'"></i>
                  <span class="notif-item__priority-dot"
                    [ngClass]="{
                      'notif-item__priority-dot--red': item.notificacao.prioridade === 'Urgente',
                      'notif-item__priority-dot--yellow': item.notificacao.prioridade === 'Alerta',
                      'notif-item__priority-dot--blue': item.notificacao.prioridade === 'Informacoes'
                    }"></span>
                </div>
                <div class="notif-item__content">
                  <span class="notif-item__title">{{item.notificacao.titulo}}</span>
                  <span class="notif-item__sender">{{item.notificacao.usuarioRemetente.email}}</span>
                </div>
                <div class="notif-item__meta">
                  <span class="notif-item__status"
                    [ngClass]="item.statusNotificacao === 'Lida' ? 'notif-item__status--lida' : 'notif-item__status--nao-lida'">
                    {{item.statusNotificacao === 'Lida' ? 'Lida' : 'Não Lida'}}
                  </span>
                  <i class="fa fa-paperclip notif-item__attach"></i>
                  <span class="notif-item__date">{{item.dataEnvio | subtrairHoras | date: 'dd/MM/yyyy HH:mm'}}</span>
                </div>
              </div>
              <div *ngIf="listaNotificacao.length === 0" class="notif-empty">
                <i class="fa fa-inbox"></i>
                <span>Nenhuma notificação encontrada</span>
              </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <!-- FALE CONOSCO + SOBRE -->
      <div class="col-sm-4">
        <div class="modern-card modern-card--contact">
          <div class="modern-card__header">
            <div class="modern-card__title-group">
              <i class="fa fa-comments modern-card__title-icon"></i>
              <h3 class="modern-card__title">Fale Conosco</h3>
            </div>
          </div>
          <div class="modern-card__body">
            <ul class="contact-list">
              <li class="contact-list__item">
                <span class="contact-list__icon contact-list__icon--blue"><i class="fa fa-at"></i></span>
                <div class="contact-list__info">
                  <span class="contact-list__label">E-mail</span>
                  <span class="contact-list__value">cge@cge.pi.gov.br</span>
                </div>
              </li>
              <li class="contact-list__item">
                <span class="contact-list__icon contact-list__icon--green"><i class="fa fa-phone"></i></span>
                <div class="contact-list__info">
                  <span class="contact-list__label">Telefone</span>
                  <span class="contact-list__value">(86) 3326-2000</span>
                </div>
              </li>
              <li class="contact-list__item">
                <span class="contact-list__icon contact-list__icon--whatsapp">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="16" height="16" fill="currentColor">
                    <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7 .9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/>
                  </svg>
                </span>
                <div class="contact-list__info">
                  <span class="contact-list__label">WhatsApp</span>
                  <a href="https://wa.link/9u2ih3" target="_blank" class="contact-list__value contact-list__value--link">(86) 99426-1735</a>
                </div>
              </li>
              <li class="contact-list__item">
                <span class="contact-list__icon contact-list__icon--blue"><i class="fa fa-globe"></i></span>
                <div class="contact-list__info">
                  <span class="contact-list__label">Portal</span>
                  <a href="https://portal.pi.gov.br/cge/" target="_blank" class="contact-list__value contact-list__value--link">portal.pi.gov.br/cge</a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- SOBRE O SIGRP -->
    <div class="row">
      <div class="col-sm-12">
        <div class="modern-card modern-card--about">
          <div class="modern-card__header">
            <div class="modern-card__title-group">
              <i class="fa fa-info-circle modern-card__title-icon"></i>
              <h3 class="modern-card__title">Sobre o SIGRP</h3>
            </div>
          </div>
          <div class="modern-card__body about-body">
            <div class="about-icon-wrap">
              <img src="./../../../favicon.ico" alt="SIGRP">
            </div>
            <p class="about-text">
              O <strong>Sistema Integrado de Gestão de Repasses</strong> é uma ferramenta on-line destinada
              à gestão de todo o ciclo de atividades — celebração, execução e prestação de contas — dos
              instrumentos de repasse, tais como parcerias, convênios, contratos de gestão e demais
              instrumentos congêneres, firmados entre o Estado, os Municípios e as Organizações da
              Sociedade Civil (OSCs).
              O sistema foi instituído pelo <strong>Decreto Estadual nº 22.023/2023</strong> e
              fundamenta-se na <strong>Lei Federal nº 13.019/2014</strong> e no
              <strong>Decreto Estadual nº 8.717/2017</strong>.
            </p>
          </div>
        </div>
      </div>
    </div>

  </section>
</div>

<!-- MODAL: AVISO ELEITORAL -->
<p-dialog [style]="{width: '800px', 'min-height': '350px'}" header="" [(visible)]="openModalAviso"
  showEffect="fade" [modal]="true">
  <div class="col-sm-12">
    <h4 class="text-center"><b>COMUNICADO</b></h4>
    <br>
    <p class="text-justify">
      Conforme estabelece o artigo 73, inciso VI, "a", da Lei das Eleições,
      nos três meses que antecedem os pleitos eleitorais estão
      <b> vedadas as transferências voluntárias de recursos </b> da União aos <b>Estados e Municípios</b>,
      e dos Estados aos Municípios, sob pena de nulidade de pleno direito,
      <b>ressalvados</b> os recursos destinados a cumprir obrigação formal preexistente para
      execução de obra ou serviço em andamento e com cronograma prefixado,
      e os destinados a atender situações de emergência e de calamidade pública.
    </p>
  </div>
</p-dialog>

<!-- MODAL: AVISO DE SENHA FRACA -->
<p-dialog [style]="{width: '640px'}" header="" [(visible)]="modalSenhaFraca"
  showEffect="fade" [modal]="true" [closable]="false" styleClass="security-modal">
  <div class="security-modal-body">
    <div class="security-modal__header-hint">
      <i class="fa fa-exclamation-triangle security-modal__hint-icon"></i>
      <div>
        <p class="security-modal__hint-title">Atenção - Segurança</p>
        <p class="security-modal__hint-desc">
          É necessário trocar sua senha para continuar. A política de segurança do sistema mudou, e a
          senha atual precisa ser substituída por uma que atenda aos requisitos abaixo.
        </p>
      </div>
    </div>

    <p class="security-modal__rules">
      <i class="fa fa-info-circle"></i>
      Recomenda-se que a senha contenha pelo menos 8 caracteres, com a combinação de letras maiúsculas e
      minúsculas, números e caracteres especiais.
    </p>

    <div class="security-modal__form">
      <div class="security-modal__field">
        <label>Senha atual</label>
        <input type="password" [(ngModel)]="senhaAtual" class="form-control"
          placeholder="A senha com que você acabou de entrar">
      </div>
      <div class="security-modal__field">
        <label>Nova senha</label>
        <input type="password" pPassword [(ngModel)]="novaSenha" [feedback]="true"
          [promptLabel]="'Digite sua nova senha'" [weakLabel]="'Fraca'" [mediumLabel]="'Média'" [strongLabel]="'Forte'"
          class="form-control">
        <p class="security-modal__field-error" *ngIf="problemasDaSenha.length">
          <i class="fa fa-exclamation-triangle"></i> Falta: {{ problemasDaSenha.join(', ') }}.
        </p>
      </div>
      <div class="security-modal__field">
        <label>Confirmar senha</label>
        <input type="password" pPassword [(ngModel)]="confirmarSenha" [feedback]="true"
          [promptLabel]="'Confirme sua nova senha'" [weakLabel]="''" [mediumLabel]="''" [strongLabel]="''"
          class="form-control">
        <p class="security-modal__field-error"
          *ngIf="novaSenha.length > 3 && confirmarSenha.length > 3 && novaSenha !== confirmarSenha">
          <i class="fa fa-exclamation-triangle"></i> As senhas não correspondem
        </p>
      </div>
    </div>

    <div class="security-modal__footer">
      <button pButton type="button" label="Alterar senha" icon="fa fa-lock" (click)="alterarSenha()"
        [disabled]="!podeAlterarSenha" class="ui-button-primary security-modal__submit"></button>
    </div>
  </div>
</p-dialog>
